import React, { ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import {
  useRefreshTokenMutation,
  useValidTokenMutation,
} from "../../store/api/authApi";
import CircleLoader from "../CircleLoader";
import { setCredentials } from "../../store/slices/authSlice";
import { useDispatch } from "react-redux";
import Loadingpage from "../Loadingpage";

interface AuthWrapperProps {
  children: ReactNode;
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const authData = useSelector((state: any) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [
    refreshToken,
    { data: refreshTokenData, isLoading: isRefreshInProgress },
  ] = useRefreshTokenMutation();
  const [
    checkForValidToken,
    { data: checkValidToken, isLoading: validationInProgress },
  ] = useValidTokenMutation();
  useEffect(() => {
    checkForValidToken({ token: authData?.data?.token } as any)
      .unwrap()
      .then((result) => {
        setLoading(false);
        if (
          location.pathname === "/login" ||
          location.pathname === "/reset-password"
        ) {
          navigate("/", { replace: true });
        }
      })
      .catch((err) => {
        if (err) {
          refreshToken({ refreshToken: authData?.data?.refreshToken } as any)
            .unwrap()
            .then((rResult: any) => {
              setLoading(false);
              const tempAuthData: any = structuredClone(authData);
              tempAuthData.data.token = rResult.data.token;
              tempAuthData.data.refreshToken = rResult.data.refreshToken;
              dispatch(setCredentials(tempAuthData));
              localStorage.setItem("auth", JSON.stringify(tempAuthData));
              if (
                location.pathname === "/login" ||
                location.pathname === "/reset-password"
              ) {
                navigate("/", { replace: true });
              }
            })
            .catch((rerror) => {
              setLoading(false);
              dispatch(setCredentials(null as any));
              localStorage.removeItem("auth");
            });
          navigate("/login");
        }
      });
  }, []);

  return (
    <div>
      {(validationInProgress || isRefreshInProgress || loading) && (
        <Loadingpage />
      )}{" "}
      <div>{children}</div>{" "}
    </div>
  );
};

export default AuthWrapper;
